import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSmartLeverage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m5.487 5.5.041.387A2.26 2.26 0 0 0 7.5 7.882a2.403 2.403 0 0 0-1.963 2.116l-.05.502-.046-.506A2.376 2.376 0 0 0 3.5 7.882a2.233 2.233 0 0 0 1.95-1.99l.037-.392Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M16.826 8.138a.8.8 0 0 1 1.115-.19 9.847 9.847 0 0 1 2.74 2.944.8.8 0 1 1-1.37.827 8.247 8.247 0 0 0-2.294-2.466.8.8 0 0 1-.19-1.115Zm-11.98 2.888a.8.8 0 0 1 .165 1.12c-.463.62-.924 1.943-.91 3.283a.8.8 0 1 1-1.6.015c-.017-1.63.522-3.307 1.226-4.253a.8.8 0 0 1 1.119-.165ZM2.018 18.521a.806.806 0 0 1 .608-.964l18.408-4.763a.806.806 0 0 1 .948.634.806.806 0 0 1-.608.964L2.966 19.155a.806.806 0 0 1-.948-.634Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M10.845 16.55c.513-.733 1.796-.733 2.31 0l2.664 3.802c.514.732-.128 1.648-1.154 1.648h-5.33c-1.026 0-1.668-.916-1.154-1.648l2.664-3.803ZM12 17.605l-2.132 3.042h4.264L12 17.606Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M11.937 2.002c.4.027.703.358.675.74l-.067.923 1.347.09c.401.028.703.36.676.742-.028.382-.376.67-.777.643l-3.04-.204c-.668-.045-1.247.435-1.293 1.072-.047.637.457 1.19 1.125 1.235l1.935.13c1.47.098 2.577 1.315 2.475 2.716-.102 1.402-1.375 2.458-2.845 2.36l-.242-.017-.067.923c-.028.382-.375.67-.776.643-.4-.027-.703-.358-.675-.74l.067-.923-1.347-.09c-.401-.028-.703-.36-.675-.741.027-.383.375-.67.776-.644l3.04.204c.668.045 1.247-.435 1.293-1.072.047-.637-.457-1.19-1.125-1.235l-1.935-.13c-1.47-.098-2.578-1.314-2.475-2.716.102-1.402 1.375-2.458 2.845-2.36l.242.017.067-.923c.028-.382.375-.67.776-.643Z"
    />
  </svg>
);
export default SvgTwoColorSmartLeverage;
